import { InjectionToken } from '@angular/core';

export const USE_TEMP_MEDIA_UPLOAD = new InjectionToken<boolean>('UseTempMediaUpload');
